    import React from 'react';

const ArmoredReactorFigure = () => (
  <aside className="armored-figure" aria-label="Armored energy figure">
    <svg viewBox="0 0 240 400" role="img" aria-hidden="true">
      <defs>
        <linearGradient id="hero-red" x1="0" y1="0" x2="1" y2="1"><stop stopColor="#ff6464" /><stop offset=".55" stopColor="#d42f38" /><stop offset="1" stopColor="#781923" /></linearGradient>
        <linearGradient id="hero-gold" x1="0" y1="0" x2="1" y2="1"><stop stopColor="#ffea9b" /><stop offset=".52" stopColor="#e5ad32" /><stop offset="1" stopColor="#905a0b" /></linearGradient>
        <linearGradient id="hero-dark" x1="0" y1="0" x2="1" y2="1"><stop stopColor="#536172" /><stop offset="1" stopColor="#1d2632" /></linearGradient>
      </defs>

      <path d="M82 18h76l12 32-9 52-18 14H97l-18-14-9-52z" fill="url(#hero-red)" stroke="#651923" strokeWidth="6" />
      <path d="M90 29h60l11 27-8 35-16 13h-34L87 91l-8-35z" fill="url(#hero-red)" />
      <path d="M98 48h44l7 18-8 23-16 9h-10l-16-9-8-23z" fill="url(#hero-gold)" />
      <path d="M102 65h18l-6 11h-15zm18 0h18l3 11h-15z" fill="#dfffff" />
      <path d="M106 94h28l-5 14h-18z" fill="url(#hero-dark)" />

      <path d="M51 123l31-13 25 22-17 50-43 12-17-26zM189 123l-31-13-25 22 17 50 43 12 17-26z" fill="url(#hero-red)" stroke="#651923" strokeWidth="5" />
      <path d="M54 135l27-11 11 17-12 22-25 7-8-13zm132 0-27-11-11 17 12 22 25 7 8-13z" fill="url(#hero-gold)" />
      <path d="M64 177l-22 60 30 12 34-61-17-22zm112 0 22 60-30 12-34-61 17-22z" fill="url(#hero-red)" stroke="#651923" strokeWidth="7" />
      <path d="M49 191l18 7-13 39-16-5zm142 0-18 7 13 39 16-5z" fill="url(#hero-gold)" />
      <path d="M44 235l22 9-11 24-20-8zm152 0-22 9 11 24 20-8z" fill="url(#hero-gold)" stroke="#651923" strokeWidth="3" />

      <path d="M74 112h92l28 82-20 92H66l-20-92z" fill="url(#hero-red)" stroke="#651923" strokeWidth="7" />
      <path d="M87 127h66l20 62-15 69H82l-15-69z" fill="url(#hero-gold)" />
      <path d="M91 139h28l-13 43-26 8zm58 0h-28l13 43 26 8z" fill="url(#hero-red)" />
      <path d="M87 209h66l13 44H74z" fill="url(#hero-dark)" />
      <path d="M101 223h38l8 23H93z" fill="#1e2937" opacity=".8" />

      <path d="M77 278L48 382l48 9 31-106-23-16zm86 0 29 104-48 9-31-106 23-16z" fill="url(#hero-red)" stroke="#651923" strokeWidth="6" />
      <path d="M89 287h28l-18 88H63zm34 0h28l26 88h-36z" fill="url(#hero-gold)" />
      <path d="M55 374h47v15H49zm83 0h47l6 15h-53z" fill="url(#hero-dark)" />

      <circle className="reactor-halo" cx="120" cy="184" r="39" />
      <circle className="reactor-ring" cx="120" cy="184" r="27" />
      <circle className="reactor-core" cx="120" cy="184" r="16" />
      <path d="M120 165l8 19-8 19-8-19z" fill="#fff" />
    </svg>
  </aside>
);

export default ArmoredReactorFigure;
